import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

function IsLeasing(props) {
  const { order } = useContext(ConfiguratorContext)

  if (order.paymentType !== 'leasing') return null

  return <>{props.children}</>
}

export default observer(IsLeasing)
